import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Login from "../login/login";
import Register from "../register/register";
import Forget from "../forget/forget";
import Reset from "../forget/reset";
import { Dropdown, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/images/header/logo-text.svg";
import user from "../../assets/images/header/avatar.png";
import gem from "../../assets/images/header/gem.png";
import menu1 from "../../assets/images/header/menu1.svg";
import menu2 from "../../assets/images/header/menu2.svg";
import menu3 from "../../assets/images/header/menu3.svg";
import menu4 from "../../assets/images/header/menu4.svg";
import menu5 from "../../assets/images/header/menu5.svg";
// import notification from "../../assets/images/header/notification.svg";
import menuicon from "../../assets/images/header/menuicon.svg";
import searchicon from "../../assets/images/header/search.svg";
import ethereumsm from "../../assets/images/coins/ethereum-sm.svg";
import ethereummd from "../../assets/images/coins/ethereum-md.svg";
import arrow from "../../assets/images/coins/arrow-left.svg";
import "./header.css";
import Cashier from "../modals/cashier";
import qr from "../../assets/images/coins/qr.svg";
import danger from "../../assets/images/coins/danger.svg";
import dollar from "../../assets/images/coins/dollar-black.svg";
import singelgem from "../../assets/images/header/gem.png";
import searchActive from "../../assets/images/header/search-active.svg";

const Header = ({ handleSidebar, search }) => {
  const [show, setShow] = useState(false);
  const handleModal = (e) => {
    setShow(e);
  };

  return (
    <div className="header">
      <div className="header-top-area">
        <div className="header-logo-menu">
          <div className="menu-icon">
            <Button onClick={handleSidebar}>
              <img src={menuicon} alt="" />
            </Button>
          </div>
          <div className={`search-icon ${search ? "active-search" : ""}`}>
            <Link to="/search">
              {search ? (
                <img src={searchActive} alt="" />
              ) : (
                <img src={searchicon} alt="" />
              )}
            </Link>
          </div>
          <div className="header-logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
        </div>

        {/* <div className="loggedoff-menu">
                <ul>
                <li><span role="presentation"  onClick={()=>handleModal("login")}>Login</span></li>
                <li><span role="presentation"  onClick={()=>handleModal("register")}><i className="fa fa-steam" /> Sign In</span></li>
                </ul>
            </div> */}

        <div className="loggedin-menu">
          <div className="credit-input">
            <Form>
              <img src={gem} alt="coin" />
              <Form.Control
                type="number"
                placeholder="245.91"
                name="amount"
                autoComplete="off"
              />
              <Button onClick={() => handleModal("cashier")}>DEPOSIT</Button>
            </Form>
          </div>
        </div>

        <div className="my-profile-menu">
          <div className="p-name">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-profile">
                Madness
                <div className="p-pic">
                  <img src={user} alt="" />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Link to="/settings">
                  <img src={menu1} alt="" /> User Profile
                </Link>
                <Link to="/blog">
                  <img src={menu2} alt="" /> Blog
                </Link>
                <Link to="/affiliates">
                  <img src={menu3} alt="" /> Affiliates
                </Link>
                <Link to="/rewards">
                  <img src={menu4} alt="" /> Rewards
                </Link>
                <Dropdown.Item>
                  <img src={menu5} alt="" /> Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* <div className='notification-icon'>
            <Button>
              <img src={notification} alt='' />
            </Button>
          </div> */}
        </div>
      </div>

      <Modal
        centered
        className="login-popup"
        show={show === "login"}
        onHide={() => handleModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Login handleModal={handleModal} />
        </Modal.Body>
      </Modal>

      <Modal
        centered
        className="signup-popup"
        show={show === "register"}
        onHide={() => handleModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Register handleModal={handleModal} />
        </Modal.Body>
      </Modal>

      <Modal
        centered
        className="login-popup"
        show={show === "forget"}
        onHide={() => handleModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Forget handleModal={handleModal} />
        </Modal.Body>
      </Modal>

      <Modal
        centered
        className="login-popup"
        show={show === "reset"}
        onHide={() => handleModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Reset handleModal={handleModal} />
        </Modal.Body>
      </Modal>

      {/* *********** Cashier Modal Start ********** */}
      <Modal
        className="cashier-modals"
        show={show === "cashier"}
        onHide={() => handleModal("")}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cashier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Cashier handleModal={handleModal} />
        </Modal.Body>
      </Modal>
      {/* *********** Cashier Modal End********** */}

      {/* *********** Deposit Modal Start ********** */}

      <Modal
        className="qr-modal"
        show={show === "bitcoin-deposit"}
        onHide={() => handleModal("")}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cashier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="qr-code-modal">
            <div className="qr-coin-type">
              <div className="qr-back-arrow" onClick={() => setShow("cashier")}>
                <img src={arrow} alt="" />
              </div>
              <div className="qr-coin-name">
                <h6>
                  <img src={ethereumsm} alt="" />
                  Ethereum
                </h6>
                <p>Crypto</p>
              </div>
            </div>
            <div className="address-form">
              <Form>
                <Form.Group>
                  <Form.Label>Deposit Address</Form.Label>
                  <div className="ref-input">
                    <Form.Control
                      type="text"
                      placeholder="0xec6661f21a352ca572a1bc11738c62e2407146c9"
                    />
                    <div className="ref-input-btn ref-btn-copy">
                      <Button className="ref-btn-copy">Copy</Button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </div>
            <div className="qr-address">
              <img src={qr} alt="" />
            </div>
            <div className="warning-text">
              <img src={danger} alt="" />
              <p>
                Only send ETH to this address, 12 confirmation(s) required. We
                do not accept BEP20 from Binance.
              </p>
            </div>
            <div className="coin-compare">
              <div className="coin-compare-box">
                <img src={dollar} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>10.00</h6> */}
              </div>
              <span>=</span>
              <div className="coin-compare-box">
                <img src={singelgem} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>10.00</h6> */}
              </div>
              <span>=</span>
              <div className="coin-compare-box">
                <img src={ethereummd} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>0.0555555</h6> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* *********** Deposit Modal End ********** */}

      {/* *********** Withdraw Modal Start ********** */}

      <Modal
        className="qr-modal"
        show={show === "bitcoin-withdraw"}
        onHide={() => handleModal("")}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cashier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="qr-code-modal">
            <div className="qr-coin-type">
              <div className="qr-back-arrow" onClick={() => setShow("cashier")}>
                <img src={arrow} alt="" />
              </div>
              <div className="qr-coin-name">
                <h6>
                  <img src={ethereumsm} alt="" />
                  Ethereum
                </h6>
                <p>Crypto</p>
              </div>
            </div>
            <div className="address-form">
              <Form>
                <Form.Group>
                  <Form.Label>Ethereum Address</Form.Label>
                  <div className="ref-input">
                    <Form.Control type="text" placeholder="" />
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Amount</Form.Label>
                  <div className="ref-input">
                    <Form.Control type="number" placeholder="0.00" />
                    <div className="ref-input-btn ">
                      <Button className="ref-btn-copy">MAX</Button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </div>
            <div className="withdarw-btn">
              <Button>WITHDRAW</Button>
            </div>
            <div className="warning-text">
              <img src={danger} alt="" />
              <p>
                Minimum withdrawl is $22.59. Your withdrawl will have a fee of
                $8.90.
              </p>
            </div>
            <div className="coin-compare">
              <div className="coin-compare-box">
                <img src={dollar} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>10.00</h6> */}
              </div>
              <span>=</span>
              <div className="coin-compare-box">
                <img src={singelgem} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>10.00</h6> */}
              </div>
              <span>=</span>
              <div className="coin-compare-box">
                <img src={ethereummd} alt="" />
                <input type="text" placeholder="10.00" />
                {/* <h6>0.0555555</h6> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* *********** Withdraw Modal End ********** */}
    </div>
  );
};

export default Header;
